import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import ForkliftTable from './forklift-table';
import ForkliftTile from './forklift-tile';
import ForkliftSearch from './forklift-search';
import ForkliftNavBar from './forklift-nav-bar';
import { selectTileView } from './store/selectors';

const ForkliftContent = props => {
  const [activeLane, setActiveLane] = useState('ALL');
  const tileView = useSelector(selectTileView);

  return (
    <div className="card table-list-card">
      <div className="card-body">
        <div className="table-top w-100">
          <ForkliftSearch />
        </div>
        <div className="d-flex">
          <ForkliftNavBar onLaneChange={setActiveLane} activeLane={activeLane} />
          {!tileView ? <ForkliftTable activeLane={activeLane} /> : <ForkliftTile />}
        </div>
      </div>
    </div>
  );
};

export default ForkliftContent;
